import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import cx from 'classnames';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import AdsCard from '@components/AdsCard';
import EditDropdown from '@components/EditDropdown';
import { ForumManageMenu } from '~/services/config';

const TopicList = ({ adsData, data, displayMenu, userRole, page, perPage, onMenu, communityId }) => {
    const navigate = useNavigate();
    const userID = useSelector((state) => state.app.user?.community_user_id);

    if (!data) return null;

    return (
        <>
            {data?.length > 0 ? (
                data.map((item, idx) => {
                    const { id, name, categories, comments, stats, user_id } = item;
                    const authorName = `${comments[0]?.user?.first_name} ${comments[0]?.user?.last_name}`;
                    const categoryId = categories[0].id;
                    const categoryName = categories[0].name;
                    const ads = adsData[idx % 3];

                    if (ads && idx % 4 === 3) {
                        return <AdsCard className="forum" size="tiny" data={ads} key={`ads-${idx}`} />;
                    }

                    return (
                        <div className="forum mb-3" key={id} onClick={() => navigate(`/community/forums/${id}/${categoryId}`, { state: { page, perPage } })}>
                            <Avatar className="mr-4" name={authorName} url={comments[0]?.author_avatar} isSponsored={true} />
                            <div className="d-flex ssm-column flex-wrap d-flex-1 ms-2">
                                <div className="d-flex-1">
                                    <span className="dsl-b16 bold me-3">{name}</span>
                                    <div className="d-flex mt-1 ssm-t-0 flex-wrap">
                                        <div className={cx('d-h-start me-0 ssm-r-4', !displayMenu && 'd-flex-2')}>
                                            <span className="dsl-m12 text-400 me-1">{displayMenu ? 'By:' : 'Created by:'}</span>
                                            <span className="dsl-b14 text-nowrap">{authorName}</span>
                                        </div>
                                        {displayMenu && (
                                            <div className="d-h-start d-flex-4">
                                                <span className="mr-1 ms-sm-3 dsl-m12 text-400">In: </span>
                                                <span className="dsl-b14 text-nowrap">{categories[0]?.name}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="w-25 me-3 d-sm-block ai-center text-end">
                                    <div className="dsl-m12 text-400 mb-1 ssm-b-0 me-0 ssm-r-2 forum-department">{displayMenu ? 'New' : categoryName}</div>
                                    <div className="d-h-start">
                                        <div className="d-flex me-4 w-75">
                                            <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                                            <span className="dsl-d14 text-400">{stats?.views || 0}</span>
                                        </div>
                                        <div className="d-flex me-4 w-75">
                                            <Icon name="fas fa-thumbs-up me-2 text-500" size={12} color={stats?.liked && userID && stats?.liked[userID] ? '#376caf' : '#969faa'} />
                                            <span className={cx('dsl-d14 text-400', stats?.liked && userID && stats?.liked[userID] && 'forums-count')}>{stats?.likes || 0}</span>
                                        </div>
                                        <div className="d-flex w-75">
                                            <Icon name="far fa-comment me-2 text-500" size={12} color={'#969faa'} />
                                            <span className={cx('dsl-d14 text-400')}>{stats?.comments ?? 0}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="edit">
                                {displayMenu && (communityId === user_id || userRole === 1) && <EditDropdown options={ForumManageMenu} onChange={(e) => onMenu(e, item, page, perPage)} />}
                            </div>
                        </div>
                    );
                })
            ) : (
                <div className="dsl-b16 text-center pb-3">No recent topic available</div>
            )}
        </>
    );
};

TopicList.propTypes = {
    adsData: PropTypes.array,
    data: PropTypes.array,
    displayMenu: PropTypes.bool,
    userRole: PropTypes.number,
    communityId: PropTypes.number,
    onMenu: PropTypes.func,
};

TopicList.defaultProps = {
    adsData: [],
    data: [],
    displayMenu: false,
    userRole: null,
    communityId: null,
    onMenu: () => {},
};

export default TopicList;
